/**
 * 檔案用途區塊
 * @module WalletConnectSsoPage
 * @purpose 組裝 WalletConnect SSO 頁面版型，載入登入元件並提供頁面測試識別。
 * @external https://innotech.atlassian.net/browse/IN-111885
 */
import React from 'react';
import ContentLayout from '@shared/components/ContentLayout';
import WalletConnectLogin from '@modules/walletconnect/components/WalletConnectLogin';

/**
 * 宣告內容用途說明與單號關聯
 * @description WalletConnectSsoPage React 頁面元件。
 * @purpose 透過 ContentLayout 包裝 WalletConnectLogin，作為 WalletConnect SSO 入口頁。
 * @external https://innotech.atlassian.net/browse/IN-111885
 */
const WalletConnectSsoPage: React.FC = () => {
  return (
    <ContentLayout testId="WalletConnectSsoPage">
      <WalletConnectLogin />
    </ContentLayout>
  );
};

export default WalletConnectSsoPage;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:19:01.119Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotations (top/middle/bottom) in the specified format, mapped declaration external ticket to IN-111885 with full Jira URL, and kept runtime logic unchanged.
 */
